import * as priceutils from '~/services/Insider/utils/valuePriceTractative'

export default function formatAmountWithSymbol (params) {
  const symbol = params.totalAmountWithoutAdditionalServices.symbol
  const amountMinusRentalCover = priceutils.subTotalInds(params)
  const extras = params?.extra?.totalAmount?.value || 0
  return `${symbol} ${(amountMinusRentalCover - extras).toFixed(2)}` ?? null
}
